// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3APGR","paramInput":"JobSimulator_paramInput__e0v9h","input":"JobSimulator_input__3u-WX"};